import React from "react";
import './src/styles/global.css';
import MainLayout from "./src/layout/MainLayout";

export const wrapPageElement = ({ element, props }) => {
  return <MainLayout {...props}>{element}</MainLayout>;
};